import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { MagentoObjectDataset } from 'app/model/dataset/magento.dataset';
import { Metamodel } from 'app/model/base/model';
import { MagentoLinkedService } from 'app/model/linkedservice/magento.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const magentoObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(MagentoObjectDataset).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Magento_DisplayText),
    supportLinkedServiceTypes: [Metamodel.modelFor(MagentoLinkedService).name],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-magento'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
